"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgEnvelope(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M21.191 3A2.815 2.815 0 0124 5.809v12.255a2.814 2.814 0 01-2.809 2.808H2.81A2.814 2.814 0 010 18.064V5.809A2.815 2.815 0 012.809 3zm1.242 2.511l-9.952 8.042a.766.766 0 01-.865.068l-.098-.068-9.95-8.042a1.26 1.26 0 00-.036.298v12.255c0 .7.576 1.276 1.277 1.276H21.19c.701 0 1.277-.575 1.277-1.276V5.809a1.26 1.26 0 00-.035-.298zm-1.242-.98H2.81l-.015.001L12 11.972l9.205-7.44h-.014z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgEnvelope;
exports.default = _default;